import { connect } from 'react-redux';
import { fetchActivateAccount } from '../../../../reducers/account/activation';
import ActivateApplicantAccount from './ActivateApplicantAccount';
import { getTranslation } from "../../../../reducers/common/localization";
import { getUserEmail } from '../../../../reducers/account/userData';

const mapStateToProps = (state) => {
    return {
        translation: getTranslation(state),
        email: getUserEmail(state)
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onActivate: (token, data) => {
            dispatch(fetchActivateAccount(token, data));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ActivateApplicantAccount);



// WEBPACK FOOTER //
// ./src/components/accountManagement/activateUserAccount/activateApplicantAccount/ActivateApplicantAccount.container.js